import React, { useState, useEffect } from "react";
import axiosConn from "config/axiosConn";
import Helper from "../../../helper/Common_Helper.js";
import { Row, Col } from "reactstrap";
import { toast } from "react-toastify";
import { Button, Pagination } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Charts from "./Chart.jsx";
import StateChart from "../StateChart.jsx";
import { useSelector,useDispatch } from "react-redux";


function AdminCollaborationView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [notification, setNotification] = useState([]);
  const [chatCount, setChatCount] = useState([]);
  const [stateCount, setStateCount] = useState([]);
  const [topDistrict, setTopDistrict] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [postPerPage, setPostPerPage] = useState(10);
  const storedState =  location.state?.state ?? 0;  // location.state?.state ?? 0;
  console.log('244444444444444444444',storedState);
  const userData = useSelector(state => state.auth.user);
  const dispatch = useDispatch();

  useEffect(() => {
    const getCollaborationStateWise = async (page = 1) => {
      try {
        let postData = {
          state: storedState,
          page: page,
          limit: 1000,
        };

        // console.log("postData", postData);  
        const response = await fetch(
          "https://ecoclubs.education.gov.in/api/stateWise-collaboration",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(postData),
          }
        );

        const result = await response.json();
        // console.log("result-----------------------------------------", result);
        if (result.status === "success") {
          setNotification(result.collaborationCountStateWise.collaborations);          
          setTopDistrict(result.topDistrict);

          const Collaboration =
            result.collaborationCountStateWise.collaborationCountsByTheme.filter(
              (item) => item.state_name === storedState
            );
          setChatCount(Collaboration);

          const StateCount = result.stateCount.stateCount.filter(
            (item) => item.state === storedState
          );
          setStateCount(StateCount);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const handleNotification = async (page = 1) => {
      try {
        let postData = {};
        postData["page"] = page;
        postData["limit"] = 5000;
        // let response = await axiosConn("post", "get-collaboration", postData,{},dispatch);
        // // console.log("Response:---------------", response);
        // if (response.data.status === "success") {
        //   // console.log("Response:", response);
        //   setNotification(response.data.result.response);
        //   setTotalPages(response.data.totalPages);
        //   setCurrentPage(response.data.currentPage);
        //   setChatCount(response.data.chartCount);
        //   setStateCount(response.data.stateCount.stateCount);
        // }
      } catch (error) {
        console.log(error);
      }
    };

    // If storedState exists, fetch the data using getCollaborationStateWise
    if (storedState) {
      getCollaborationStateWise();
    } else {
      handleNotification();
    }
  }, [storedState]);

  const viewFile = (filePath, id) => {
    if (filePath.length === 0) {
      toast.warning("image not uploaded");
      return;
    }
    window.open(
      `https://ecoclubs.education.gov.in/viewUpload/${filePath}`,
      "_blank"
    );
  };

  const lastPostIndex = currentPage * postPerPage;
  const firstPostIndex = lastPostIndex - postPerPage;
  const c_post = notification?.slice(firstPostIndex, lastPostIndex);
  const total_page = Math.ceil(notification?.length / postPerPage);
  const page_arr = [...Array(total_page).keys()];
console.log(storedState, 'storedState');

  return (
    <>
      <section className="scholdashbrdSec">
        
        <div className="schlDashbrdRgt  w-100 container-fluid">
          <div className="bg-white p-3 text-start pageContainer">
            <div class="card-header dashbrdTopSrchDiv text-center">
              <h2>Collaboration Requests</h2>
              <div className="text-end">
                <Button onClick={() => navigate('/admin')}>Back</Button>
                </div>
            </div>
            <div class="dashbrdTopSrchDivTitel text-center mb-0">
              <h2>Visual Representation - Collaboration Requests</h2>
            </div>
            <Row>
              <Col xs={12} sm={12} md={12} lg={6}>
                <div className="card p-4 themewiseLineChrt">
                  <h5>No. of Collaboration Requests (Theme wise)</h5>
                  <Charts data={chatCount} />
                </div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6}>
                <div className="card p-4 statewiseLinechart">
                  <h5>No. of Collaboration Requests ({ storedState == 0 ? 'States/UTs/ABs wise' : "District wise"})</h5>
                  <StateChart data={storedState == 0 ? stateCount : topDistrict} />
                </div>
              </Col>
            </Row>
            <div class="dashbrdTopSrchDivTitel text-center mb-3">
              <h2>Collaboration Requests Details</h2>
            </div>
            <div className="table-responsive">
              <table rules="all" className="table">
                <thead className="text-primary">
                  <tr className="tblHdngOne">
                    <th>S.no</th>
                    <th>Contact Person</th>
                    <th>Contact Email</th>
                    <th>Contact Number</th>
                    <th>Date of Request & Time</th>
                    <th>Event Name</th>
                    <th>View Document</th>
                    <th>Req Sent To School Name</th>
                    <th>Req Sent From School Name</th>
                    {/* <th>Event Date and Time</th> */}
                    <th>Comments</th>
                  </tr>
                </thead>
                <tbody>
                  {notification && notification.length > 0 ? (
                    c_post
                      .sort(
                        (a, b) =>
                          new Date(b.created_at) - new Date(a.created_at)
                      )
                      .map((item, i) => (
                        <tr key={item._id}>
                          <td>{(currentPage - 1) * 10 + i + 1}</td>
                          <td>{item.contact_person}</td>
                          <td>{item.contact_email}</td>
                          <td>{item.contact_number}</td>
                          <td>{Helper.formatDate(item.created_at)}</td>
                          <td>{item.event_name}</td>
                          <td>
                            <button
                              className="btn btn-success"
                              onClick={() => viewFile(item?.file, item._id)}
                            >
                              View
                            </button>
                          </td>
                          <td>{item?.collab_to_school_name}</td>
                          <td>{item?.collab_by_school_name}</td>
                          <td>{item.comment}</td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center">
                        Data not found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {notification ? (
              <div className="d-flex justify-content-center">
                <Pagination>
                  {page_arr.map((i, x) => (
                    <Pagination.Item
                      key={i}
                      onClick={() => {
                        setCurrentPage(i + 1);
                      }}
                      active={i + 1 === currentPage}
                    >
                      {i + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default AdminCollaborationView;
